import React from 'react';
import "../style/SimpleTitleStyle.scss"

const SimpleTitleComponent = props => {

    const { title } = props;

    return (
        <h3 className="simpleTitle">
            <span className="underline"> </span>  <span className="title">{ title }</span> <span className="underline"> </span>
        </h3>
    );
};

export default SimpleTitleComponent;